import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import { EBaseUrl } from '../models/enums/env.enum';
import { api } from '../utils';

const initialState: any = {
    preOrderData:{},
    preOrderList:[]
  };

  interface IFormData {
    key:string | undefined;
    route:string;
    json:any;
  } 

  const name = 'Preorder';

  export const updatePreOrder = createAsyncThunk(
    `${name}/updatePreOrder`,
    async (formData:IFormData) => {
      return api({
        method: 'POST',
        url: `${EBaseUrl.envLetter}/${name}`,
        body:formData,
      });
    },
  );

  export const getPreOrder = createAsyncThunk(
    `${name}/getPreOrder`,
    async (key: string | any) => {
      return api({
        method: 'GET',
        url: `${EBaseUrl.envLetter}/${name}?key=${key}`,
      });
    },
  );

const preOrderSlice = createSlice({
    name,
    initialState,
    reducers: {
      removePreOrderListData(state) {
        state.preOrderList = [];
      },
    },
    extraReducers: builder => {
      builder.addCase(updatePreOrder.fulfilled, (state, {payload}) => {
        state.preOrderList = payload;
      });
      builder.addCase(getPreOrder.fulfilled, (state, {payload}) => {
        state.preOrderList = payload;
      });
    }
  });

  export const {removePreOrderListData} =
  preOrderSlice.actions;

  export const selectPreOrderList = (state: any) => state.preOrder.preOrderList;
  
  export default preOrderSlice.reducer;